export default __webpack_public_path__ + "static/media/elephant2.0969d56e.png";